<template>
    <v-container class="pa-0 px-1" fluid v-if="!loading">
        <v-card class="pa-2">
            <v-row cols="12">
                <v-col cols="12">
                    <v-text-field v-model="search" label="Search agents" single-line hide-details prepend-icon="mdi-magnify"></v-text-field>
                </v-col>
            </v-row>
            <v-data-table 
                :items="agents" 
                :items-per-page="10" 
                :footer-props="{'items-per-page-options': [10, 50, 100, -1]}"
                :headers="headers"
                :search="search">
                <template v-slot:item="agent">
                    <tr>
                        <td class="pr-0 click_cell" @click="openAgent(agent.item.agent_code)">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">{{ agent.item.agent_code }}</span>
                                </template>
                                <span>Edit preferences {{ agent.item.agent_code }}</span>
                            </v-tooltip>
                        </td>
                        <td>{{ agent.item.agent_naam }}</td>
                        <td>{{ agent.item.new_lead_emails_text }}</td>
                        <td>{{ agent.item.action_reminder_emails_text }}</td>
                        <td>
                            <div>
                                <btn_component type="text" tooltip="Edit preferences"  :data="agent.item.agent_code" text="Edit"  size="x-small" @actionClick="openAgent"/>
                            </div>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <agentPref ref="agentPref" @actionClick="actionClick"/>
    </v-container>
    <v-container class="pa-5 px-1" fluid v-else>
        <cardWait/>
    </v-container>
</template>

<script>
    import btn_component from "@/components/ui/buttons/btn_component.vue";
    import cardWait from "@/components/pten/cardWait.vue";
    import agentPref from '@/components/pten/agentPref.vue';
    
    export default {
        components: {
            btn_component,
            cardWait,
            agentPref,
        },
        props: {
        },
        data() {
            return {
                loading: true,
                search: "",
                agents: [],
                headers: [
                    {text: "User code", value: "agent_code"},
                    {text: "Agent name", value: "agent_name"},
                    {text: "New lead emails", value: "new_lead_emails_text"},
                    {text: "Overdue action emails", value: "action_reminder_emails_text"},
                    {text: "Actions", value: "", width: "170px"},
                ],
            }
        },
        mounted() {
            this.loading = true;
            this.agents = [];
            this.getPtenAgents();
        },
        methods: {
            getPtenAgents() {
                this.$axios.post("ares/json/ares/pten/getPtenAgents.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getPtenAgents"
                    },
                    getPtenAgents: {
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.agents = res.data.getPtenAgents;
                        this.loading = false;
                    }
                });
            },
            openAgent(agent) {
                this.$refs.agentPref.openDialog(agent);
            },
            actionClick(action) {
                switch (action) {
                    case "refresh":
                        this.getPtenAgents();
                        break;
                    default:
                        break;
                }
            },
        }
    };
</script> 

<style scoped>
    .click_cell {
        cursor: pointer;
        text-decoration: underline;
        color: blue;
    }
</style>
